import { HTMLAttributes } from 'react'
import { cn } from '../utilities.ts'
import { ChildrenProp } from '../types_and_interfaces.ts'

type CardProps = HTMLAttributes<HTMLDivElement> & ChildrenProp

export const Card = ({ className, children, ...props }: CardProps) => {
  return (
    <div
      className={cn(
        'divide-y divide-gray-200 overflow-hidden rounded-lg bg-white border shadow',
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}

type CardHeaderProps = HTMLAttributes<HTMLDivElement> & ChildrenProp
export const CardHeader = ({
  className,
  children,
  ...props
}: CardHeaderProps) => {
  return (
    <div className={cn('px-4 py-5 sm:px-6', className)} {...props}>
      {children}
    </div>
  )
}

type CardFooterProps = HTMLAttributes<HTMLDivElement> & ChildrenProp
export const CardFooter = ({
  className,
  children,
  ...props
}: CardFooterProps) => {
  return (
    <div className={cn('px-4 py-4 sm:px-6', className)} {...props}>
      {children}
    </div>
  )
}

type CardContentProps = HTMLAttributes<HTMLDivElement> & ChildrenProp
export const CardContent = ({
  className,
  children,
  ...props
}: CardContentProps) => {
  return (
    <div className={cn('px-4 py-5', className)} {...props}>
      {children}
    </div>
  )
}
